// Sheet utility functions and constants
export const defaultSpreadsheetConfig = {
  properties: {
    title: 'LebSpend Expenses',
  },
  sheets: [{
    properties: {
      title: 'Expenses',
      index: 0,
      sheetType: 'GRID',
      gridProperties: {
        rowCount: 1,
        columnCount: 10,
      },
    },
    data: [{
      startRow: 0,
      startColumn: 0,
      rowData: [{
        values: [
          {userEnteredValue: {stringValue: 'Date'}},
          {userEnteredValue: {stringValue: 'Description'}},
          {userEnteredValue: {stringValue: 'Category'}},
          {
            userEnteredValue: {stringValue: 'USD'},
            userEnteredFormat: { numberFormat: { type: 'CURRENCY', pattern: '$##,##0.00' } },
          },
          {
            userEnteredValue: {stringValue: 'LBP'},
            userEnteredFormat: { numberFormat: { type: 'NUMBER', pattern: '###,###,##0' } },
          },
          {
            userEnteredValue: {stringValue: 'Rate'},
            userEnteredFormat: { numberFormat: { type: 'NUMBER', pattern: '###,###,##0' } },
          },
          {userEnteredValue: {stringValue: 'Account'}},
        ]
      }],
    }],
  }, {
    properties: {
      title: 'Exchanges',
      index: 1,
      sheetType: 'GRID',
      gridProperties: {
        rowCount: 1,
        columnCount: 10,
      },
    },
    data: [{
      startRow: 0,
      startColumn: 0,
      rowData: [{
        values: [
          { userEnteredValue: { stringValue: 'Date' } },
          { userEnteredValue: { stringValue: 'StartRow' } },
          {
            userEnteredValue: { stringValue: 'USD' },
            userEnteredFormat: { numberFormat: { type: 'CURRENCY', pattern: '$##,##0' } },
          },
          {
            userEnteredValue: { stringValue: 'Rate' },
            userEnteredFormat: { numberFormat: { type: 'NUMBER', pattern: '###,###,##0' } },
          },
          {
            userEnteredValue: { stringValue: 'LBP' },
            userEnteredFormat: { numberFormat: { type: 'NUMBER', pattern: '###,###,##0' } },
          },
          {
            userEnteredValue: { stringValue: 'Used' },
            userEnteredFormat: { numberFormat: { type: 'NUMBER', pattern: '###,###,##0' } },
          },
          {
            userEnteredValue: { stringValue: 'Remaining' },
            userEnteredFormat: { numberFormat: { type: 'PERCENT' } },
          },
          {
            userEnteredValue: { stringValue: 'TotalLBP' },
            userEnteredFormat: { numberFormat: { type: 'NUMBER', pattern: '###,###,##0' } },
          },
          {
            userEnteredValue: { stringValue: 'TotalUsed' },
            userEnteredFormat: { numberFormat: { type: 'NUMBER', pattern: '###,###,##0' } },
          },
          {
            userEnteredValue: { stringValue: 'TotalRemaining' },
            userEnteredFormat: { numberFormat: { type: 'NUMBER', pattern: '###,###,##0' } },
          },
        ],
      }],
    }],
  }, {
    properties: {
      title: 'Categories',
      index: 2,
      sheetType: 'GRID',
      gridProperties: {
        rowCount: 20,
        columnCount: 10,
      },
    },
    data: [{
      startRow: 0,
      startColumn: 0,
      rowData: [{
        values: [
          { userEnteredValue: { stringValue: 'Category' } },
          { userEnteredValue: { stringValue: 'Accounts' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Clothing & Footwear' } },
          { userEnteredValue: { stringValue: 'Cash' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Food & Drink' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Gifts' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Groceries' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Health & Personal Care' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Home & Utilities' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Household Goods' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Leisure' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Other' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Transport' } }
        ],
      }, {
        values: [
          { userEnteredValue: { stringValue: 'Travel' } }
        ],
      }],
    }],
  }],
};
